import { EXCHANGE_HOLIDAYS, EXCHANGE_HOLIDAYS_ERROR, EXCHANGE_HOLIDAYS_HIDE_ERROR, EXCHANGE_HOLIDAYS_START_LOADER, EXCHANGE_HOLIDAYS_STOP_LOADER, } from "@frameworks/web/redux/interfaces/StaticFooter/iExchangeHoliday";
const initState = {
    data: { BSE: [], NSE: [] },
    loader: false,
    errorData: {
        error: undefined,
        isOpen: false,
    },
};
const ExchangeHolidayReducer = (state = initState, action) => {
    switch (action.type) {
        case EXCHANGE_HOLIDAYS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case EXCHANGE_HOLIDAYS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EXCHANGE_HOLIDAYS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case EXCHANGE_HOLIDAYS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case EXCHANGE_HOLIDAYS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ExchangeHolidayReducer;
